/**
 * @group Constants
 * @internal
 *
 * @summary
 * <blockquote>Console field labels</blockquote>
 *
 * @example
 * ```typescript
 * import { CONSOLE_FIELDS } from '@shared/reporting';
 *
 * console.log(CONSOLE_FIELDS.EVENT_ID); // 'Event ID'
 * ```
 */
export const CONSOLE_FIELDS = {
  EVENT_ID: 'Event ID',
  EVENT_NAME: 'Event Name',
  RESOURCE: 'Resource',
  USER_ID: 'User ID',
  TIMESTAMP: 'Timestamp'
} as const;
